import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbWebResources from "abweb/generated/locale/AbWebResources";
import { observable, makeObservable } from "mobx";
export let FailedToFetchErrorRendererMachine = (_class = class FailedToFetchErrorRendererMachine {
  constructor(error) {
    _defineProperty(this, "showCausedBy", true);
    _initializerDefineProperty(this, "_error", _descriptor, this);
    makeObservable(this);
    this._error = error;
  }
  get causedBy() {
    return this._error.causedBy;
  }
  get stackTrace() {
    return this._error.stack ?? null;
  }
  get title() {
    return AbWebResources.failed_to_fetch_title();
  }
  get error() {
    return this._error;
  }
  get message() {
    return AbWebResources.failed_to_fetch_message();
  }
  getSupportDetailsText() {
    return null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
//# sourceMappingURL=FailedToFetchErrorRendererMachine.js.map
